import { useLocation } from 'react-router-dom';

import { useDevices } from 'utils/devices';

import { resolveSplitPageConfig } from './splitPageConfig';

export const useSplitPageConfig = () => {
  const { pathname } = useLocation();
  const { device } = useDevices();

  return resolveSplitPageConfig(pathname, device);
};
